module.exports = __webpack_public_path__ + "img/GajiKilat-Logo@3x.5577fe9b.png";